
<template>
    <div v-if="show">
        <div class="overlay" @click="onCloseModal"></div>
        <div class="modal" :class="typeToClass(type)">
            <div class="modal-title" v-if="title">
                {{ title }}
            </div>
            <div class="modal-content" v-if="message" v-html="message">
            </div>
            <div class="modal-content" v-if="renderCustomContent">
                <slot name="content" />
            </div>
            <div class="options" v-if="options && options.length">
                <button class="btn btn-3d"
                    :class="{
                        ['btn-primary']: (option.type ? option.type === 'primary' : i),
                        ['btn-muted']: (option.type ? option.type === 'secondary' : !i),
                    }"
                    v-for="(option, i) in options" :key="`option-${i}`"
                    @click="option.callback"
                >
                    {{ option.label }}
                </button>
            </div>
            <div class="close-btn" v-if="renderCloseBtn" @click="onCloseModal">
                <fa-icon class="icon" icon="times" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'message',
        'onClose',
        'options',
        'title',
        'renderCloseBtn',
        'renderCustomContent',
        'show',
        'type',
    ],
    name: 'Modal',
    methods: {
        onCloseModal() {
            this.$store.dispatch('closeModal', this.type);

            if (this.onClose) {
                this.onClose();
            }
        },
        typeToClass(text) {
            return text.split(/(?=[A-Z][^A-Z])/).map(word => word.toLowerCase()).join('-');
        },
    },
};
</script>

<style scoped lang="scss">
@use "@/styles/styles.scss" as *;

.modal {

    .options {
        display: flex;
        justify-content: space-evenly;
        margin-top: 15px;
        width: 100%;

        .btn {
            min-width: 75px;
        }
    }

    &.leave-game {
        padding: 20px 25px;
    }

    &.leave-game,
    &.delete-account {
        max-width: 90%;
    }

    &.shock-tactics-units-modal {

        .modal-content {
            max-width: none;
        }
    }

    &.leave-all-games {
        max-width: 425px;
    }


    &.timeout {
        display: flex;
        flex-direction: column;
        width: 425px;
        max-width: 425px;
    }

    &.actions-log {
        box-sizing: border-box;
        padding: 35px 0 10px 0;
        width: 100%;

        .modal-content {
            max-width: none;
        }

        .modal-title {
            font-size: 1rem;
            margin-bottom: 10px;
        }
    }

    &.draft-units-modal,
    &.shock-tactics-units-modal,
    &.champions-units-modal {
        max-width: min(92vw, 760px);
        width: calc(100vw - 24px);
        padding: 16px 12px 20px;

        .modal-content {
            max-width: none;
            min-width: 0;
            overflow-x: auto;
            overflow-y: hidden;
            padding-bottom: 8px;
            -webkit-overflow-scrolling: touch;
        }

        :deep(.unit-cards) {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            gap: 12px;
            min-width: 100%;
            width: max-content;
            padding: 20px 4px 4px;
            overflow-x: auto;
            overflow-y: hidden;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        :deep(.unit-card) {
            flex: 0 0 auto;
        }
    }

    .close-btn {
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 10px;

        .icon {
            font-size: 1.1em;
        }
    }
}

@media only screen and (min-width: $screen-xs) {

    .modal {

        &.leave-game,
        &.delete-account {
            max-width: 300px;
        }

        &.actions-log {
            width: 400px;
        }

    }
}

</style>
